module.exports = __webpack_public_path__ + "img/Vector2.db9fe4ae.svg";